// header js（置き換え版：既存機能＋active_wrap付与／ARIA同期／ESCクローズ）
(function () {
  const menu     = document.getElementById('fullMenu');
  const menuBtn  = document.getElementById('menuToggle');
  const header   = document.getElementById('mp-header');
  if (!menu || !menuBtn) return;

  const OPEN_CLASS = 'active';       // 既存：fullMenu用
  const WRAP_CLASS = 'active_wrap';  // 追加：#mp-header用

  // 状態反映（開く/閉じるを一箇所で管理）
  function setState(open) {
    menu.classList.toggle(OPEN_CLASS, open);
    if (header) header.classList.toggle(WRAP_CLASS, open);
    // ARIA更新
    menuBtn.setAttribute('aria-expanded', String(open));
    menu.setAttribute('aria-hidden', String(!open));
  }

  // 初期ARIA（現状のクラスに合わせて同期）
  setState(menu.classList.contains(OPEN_CLASS));

  // メニュートグル（既存＋active_wrap付与）
  menuBtn.addEventListener('click', function (e) {
    e.stopPropagation(); // 外側クリック判定と競合しないように
    const willOpen = !menu.classList.contains(OPEN_CLASS);
    setState(willOpen);
  });

  // メニュー外クリックで閉じる（既存＋active_wrap除去）
  document.addEventListener('click', function (e) {
    if (!menu.contains(e.target) && !menuBtn.contains(e.target)) {
      setState(false);
    }
  });

  // Escapeキーで閉じる（追加だが副作用なし）
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setState(false);
  });
})();
